<div class="input-wrapper">
  @for (underwritingAnswer of question.underwriting_answers; track $index; let i = $index) {
    @switch (underwritingAnswer.input_type) {
      @case ('number') {
        <ion-item mode="ios">
          <ion-input
            labelPlacement="floating"
            readonly="{{ readOnly }}"
            class="bold-text"
            type="number"
            value="{{ underwritingAnswer.object_answer }}"
            min="0"
            (input)="answerValue($event, i, true)"
          >
            <div slot="label">
              <ion-text class="standard-input-label">{{ showHeading ?
                underwritingAnswer.place_holder : ''}}</ion-text>
            </div>
          </ion-input>
        </ion-item>
        @if (error) {
          <p class="error-message">{{ error }}</p>
        }
      }
      @case ('text') {
        <ion-item mode="ios">
          <ion-input
            labelPlacement="floating"
            class="bold-text"
            readonly="{{ readOnly }}"
            type="text"
            value="{{ underwritingAnswer.object_answer }}"
            (input)="answerValue($event, i, false)"
          >
            <div slot="label">
              <ion-text class="standard-input-label">{{ showHeading ?
                underwritingAnswer.place_holder : ''}}</ion-text>
            </div>
          </ion-input>
        </ion-item>
        @if (error) {
          <p class="error-message">{{ error }}</p>
        }
      }
    }
  }
</div>
